module.exports = __webpack_public_path__ + "static/img/natural-disaster-fund-alt-logo.0bb22c46.png";